import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/case-studies/rodeo/header-bg.webp";

function Banner() {
  return (
    <section
      className="banner_amj banner_teemates"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo banner_rodeo">
              <StaticImage
                src="../../../images/case-studies/rodeo/logo.png"
                alt="TekRevol"
                className="logo_amj"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={189}
                height={205}
              />
            </div>
            <h1 className="h3" style={{ color: "#000" }}>
              Rodeo Social: Revolutionizing Social Media Dynamics for Teams
            </h1>
            <p>
              Rodeo Social stands as an efficiently interactive platform in the
              realm of social media management.This multi-platform scheduling
              app empowers businesses and teams to seamlessly manage, schedule,
              and post content across various social media platforms.
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/us/app/rodeo-social-media-scheduler/id6447687420">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="mt-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="rodeo_banner_img">
              <StaticImage
                src="../../../images/case-studies/rodeo/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={604}
                height={730}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
